// extracted by mini-css-extract-plugin
module.exports = {"responsibilitesList":"experience-module--responsibilites-list--1tP7W","responsibilitiesFilter":"experience-module--responsibilities-filter--w4Clb"};